module.exports = __webpack_public_path__ + "static/media/distortion_sl_results.a19f1f7e.png";